/* eslint-disable no-use-before-define */
import React from 'react'
import Table from './shared/Table'
import Signature from './shared/Signature'
import { Document, StyleSheet, Page, View, Text, Font, Image } from '@react-pdf/renderer'
import muuveLogo from '../../assets/images/muuve-logo-2.png'

import MontserratFont from '../../assets/fonts/Montserrat-Regular.ttf'
import MontserratFontBoldFont from '../../assets/fonts/Montserrat-Bold.ttf'
import NokoraFont from '../../assets/fonts/Nokora-Regular.ttf'
import NokoraBoldFont from '../../assets/fonts/Nokora-Bold.ttf'

Font.register({ family: 'Montserrat', src: MontserratFont })
Font.register({ family: 'Montserrat Bold', src: MontserratFontBoldFont })
Font.register({ family: 'Nokora', src: NokoraFont })
Font.register({ family: 'Nokora Bold', src: NokoraBoldFont })

const MarketInvoiceReport = () => {
  const params = JSON.parse(localStorage.getItem('invoiceState'))

  const {
    startFrom,
    endAt,
    invoiceNumber,
    invoiceDateEn,
    subtotal: subtotalObject,
    officialInfo = {},
  } = params

  const { address = {}, name = {}, phone } = officialInfo

  const { en: addressEn = '', kh: addressKh = '' } = address
  const { en: companyNameEn = '' } = name

  return (
    <Document>
      <Page size="A4" style={styles.page_1}>
        <View fixed style={styles.header} />
        <View id="p1dimg1" style={styles.p1dimg1}>
          <Image style={styles.p1img1} src={muuveLogo} id="p1img1" />
        </View>
        <View style={{ paddingRight: 100 }}>
          <Text style={{ ...styles.p5, textAlign: 'right' }}>
            <Text style={{ ...fonts.ftBig }}>INVOICE</Text>
          </Text>
          <View style={{ textAlign: 'right' }}>
            <Text style={{ ...fonts.ft3, paddingBottom: 5 }}>
              <Text>Invoice No: </Text>
              <Text style={{ ...fonts.ft2 }}>{invoiceNumber}</Text>
            </Text>
            <Text style={{ ...fonts.ft3, paddingBottom: 5 }}>
              <Text>Invoice Date: </Text>
              <Text style={{ ...fonts.ft2 }}>{invoiceDateEn}</Text>
            </Text>
          </View>
        </View>
        <View style={{ marginTop: 50, marginLeft: 30, width: 480 }}>
          <Text style={{ ...fonts.ft0 }}>BILL TO: {companyNameEn}</Text>
          <Text style={{ ...fonts.ft8, paddingBottom: 25 }}>
            <Text>អាសយដ្ឋាន: </Text>
            <Text style={{ ...fonts.ft4 }}>
              {addressKh}
              {'   '}
            </Text>
          </Text>

          <Text style={{ ...fonts.ft3, paddingBottom: 25 }}>
            <Text>Address: </Text>
            <Text style={{ ...fonts.ft2 }}>{addressEn}</Text>
          </Text>

          <Text style={{ ...fonts.ft8, paddingBottom: 5 }}>
            <Text>លេខទូរស័ព្ទ: </Text>
            <Text style={{ ...fonts.ft4 }}>{phone}</Text>
          </Text>

          {/* <Text style={{ ...fonts.ft3, paddingBottom: 5 }}>
            <Text>Phone: </Text>
            <Text style={{ ...fonts.ft2 }}>{phone}</Text>
          </Text> */}
        </View>

        <View style={{ ...styles.p0, width: 480 }}>
          <View style={{ ...tableStyles.tr }} />

          <View style={{ ...tableStyles.tr }} />

          <View style={{ ...tableStyles.tr }} />

          <View style={{ ...tableStyles.tr, ...tableStyles.spacingRow }} />
        </View>

        <Table startFrom={startFrom} endAt={endAt} subtotal={subtotalObject} type="market" />

        <View
          style={{
            ...tableStyles.tr,
            width: 595,
            paddingLeft: 70,
            marginTop: 50,
          }}
        />

        <Signature />
        <View fixed style={styles.footer} />
      </Page>
    </Document>
  )
}

const tableStyles = StyleSheet.create({
  t0: {
    width: 450,
    fontSize: 12,
    fontFamily: 'Montserrat',
  },
  trFlex: { display: 'flex', flexDirection: 'row' },
  colFlex: { display: 'flex', flexDirection: 'column' },
  trCenter: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
  tr: { marginLeft: 45, width: 507, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' },
  tableRow: {
    // display: 'flex',
    // flexDirection: 'row',
    // justifyContent: 'space-between',
  },
  spacingRow: { height: 30 },

  // td: { padding: 0, margin: 0, verticalAlign: 'bottom' },
  td1: { width: 150 },
  td5: { width: 223 },
  td12: { width: 125 },
  td23: {
    borderColor: '#000000',
    borderRight: 1,
    width: 55,
  },
  td29: {
    borderRight: 1,
    borderColor: '#000000',
    width: 55,
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  td25: {
    borderRight: 1,
    borderColor: '#000000',
    width: 30,
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  td41: {
    borderColor: '#000000',
    borderRight: 1,
    width: 30,
  },
  td425: {
    borderColor: '#000000',
    borderRight: 1,
    width: 410,
    textAlign: 'right',
  },
  td28: {
    borderRight: 1,
    borderColor: '#000000',
    width: 248,
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  td17: {
    borderRight: 1,
    borderColor: '#000000',
    width: 248,
  },
  td31: {
    borderRight: 1,
    borderColor: '#000000',
    width: 75,
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  td56: {
    borderColor: '#000000',
    borderRight: 1,
    width: 75,
  },
  td32: {
    width: 93,
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  td57: { width: 93 },
  td130: {
    borderColor: '#000000',
    borderRight: 1,
    width: 130,
  },
  td280: { borderColor: '#000000', borderRight: 1, width: 280, paddingLeft: 5 },

  td100: { width: 100 },

  tr3: { height: 16 },
  tr5: { height: 30, display: 'flex', justifyContent: 'center' },
  tr7: { height: 40, display: 'flex', justifyContent: 'center' },
  tr13: { height: 28, display: 'flex', justifyContent: 'center' },
  tr18: { height: 36 },
})
const fonts = StyleSheet.create({
  ftBig: { fontSize: 24, fontFamily: 'Montserrat Bold', color: '#ffc832' },
  ft0: {
    fontSize: 16,
    fontFamily: 'Nokora Bold',
  },
  ft1: {
    fontSize: 14,
    fontFamily: 'Montserrat',
  },
  ft2: {
    fontSize: 9,
    fontFamily: 'Montserrat',
  },
  ft3: {
    fontSize: 9,
    fontFamily: 'Montserrat Bold',
  },
  ft4: {
    fontSize: 9,
    fontFamily: 'Nokora',
  },
  ft8: {
    fontSize: 9,
    fontFamily: 'Nokora Bold',
  },
  ft12: {
    fontSize: 9,
    fontFamily: 'Montserrat',
    color: '#232222',
  },
})

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
  },
  // page_1: {
  //   position: 'relative',
  //   overflow: 'hidden',
  //   margin: '65px 0px 45px 0px',
  //   padding: 0,
  //   border: 'none',
  // },
  header: {
    marginTop: 50,
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    marginBottom: 45,
    backgroundColor: 'green',
  },
  p1dimg1: {
    width: 200,
    position: 'absolute',
    top: -45,
    left: 50,
    zIndex: -1,
  },
  p1img1: {
    width: 250,
  },

  p0: {
    textAlign: 'right',
    // paddingRight: 75,
    marginTop: 0,
    marginBottom: 0,
  },
  p1: {
    textAlign: 'left',
    paddingLeft: 75,
    marginTop: 5,
    marginBottom: 0,
  },
  p2: {
    textAlign: 'left',
    // paddingLeft: 338,
    paddingLeft: 75,
    // marginTop: 3,
    marginBottom: 0,
  },
  p3: {
    textAlign: 'left',
    paddingLeft: 259,
    marginTop: 2,
    marginBottom: 0,
  },
  p4: {
    textAlign: 'left',
    paddingLeft: 461,
    marginTop: 0,
    marginBottom: 0,
  },
  p5: {
    textAlign: 'center',
    // paddingLeft: 224,
    marginTop: 10,
    marginBottom: 10,
  },
  p6: {
    textAlign: 'center',
    // paddingLeft: 237,
    marginTop: 5,
    marginBottom: 0,
  },
  p7: {
    textAlign: 'left',
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p8: {
    textAlign: 'right',
    // paddingRight: 144,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p9: {
    textAlign: 'left',
    paddingLeft: 40,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p12: {
    textAlign: 'left',
    // paddingLeft: -109,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },

  p13: {
    textAlign: 'left',
    // paddingLeft: 135,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p14: {
    textAlign: 'center',
    // paddingLeft: 3,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p15: {
    textAlign: 'left',
    paddingLeft: 31,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p16: {
    textAlign: 'left',
    paddingLeft: 11,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p17: {
    textAlign: 'left',
    paddingLeft: 150,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p18: {
    textAlign: 'left',
    // paddingLeft: 7,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  span: {
    display: 'inline',
  },
})

export default MarketInvoiceReport



// WEBPACK FOOTER //
// ./src/components/invoice/MarketInvoiceReport.js